import type { TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';
import type { TSubmissionFeedback } from './types';

/**
 * On-demand fetcher (no React hook) for the teacher's feedback on the current
 * user's own submission — null until delivered. Used by "Download PDF".
 */
export const fetchSubmissionFeedback = async (submissionId: string): Promise<TSubmissionFeedback | null> => {
  const res = await axios.get<TSubmissionFeedback | null>(`/community-hub/form-submissions/${submissionId}/feedback`);
  return res.data || null;
};

/** The teacher's feedback on the current user's own submission — null until delivered. */
export const useGetSubmissionFeedback = (submissionId: string | null | undefined, enabled = true) =>
  useQuery<TSubmissionFeedback | null, TError>({
    queryKey: [ENTITY, 'form-submission', submissionId, 'feedback'],
    queryFn: () => fetchSubmissionFeedback(submissionId as string),
    enabled: !!submissionId && enabled,
  });
